import { useState, useEffect } from 'react';
import { Flex, Button, Text } from '@mantine/core';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { ErrorModal, ModuleView } from '@jadwalh/ui';
import instance from '../../../../../axios-instance';
import { SectionContainer } from './styles';
import { ReactComponent as TabiPayment } from '../../../../../assets/images/svg/zoom.svg';
import { useSelector } from 'react-redux';
import { getProfileData } from '../../../../../store/profile.slice';
import { useFeatureGate } from '../../../../../hooks/useFeatureGate';
import { BlockedFeatureState } from '../../../../../components/BlockedFeatureState';

export default function TabiPaymentIntegration() {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const profile = useSelector(getProfileData);
  const [isLoading, setIsLoading] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [apiKey, setApiKey] = useState('');
  const { isBlocked, hasAccess } = useFeatureGate('can_use_payments');
  const [showBlockedModal, setShowBlockedModal] = useState(false);

  const handleActivate = async () => {
    // Check if user has access to payments feature
    if (!hasAccess) {
      setShowBlockedModal(true);
      return;
    }

    if (profile.role.role_value === 2) {
      setShowErrorModal(true);
      return;
    }

    try {
      setIsLoading(true);
      const response = await instance.post('app/integrations/payment/activate');
      if (response.data.data) {
        setApiKey(response.data.data.api_key);
        setIsConnected(true);
      }
    } catch (error) {
      console.error('Error activating TabiPayment:', error);
      setShowErrorModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeactivate = async () => {
    try {
      setIsLoading(true);
      await instance.post('app/integrations/payment/deactivate');
      setIsConnected(false);
      setApiKey('');
    } catch (error) {
      console.error('Error deactivating TabiPayment:', error);
      setShowErrorModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   const checkConnection = async () => {
  //     try {
  //       const response = await instance.get('app/integrations/payment/status');
  //       if (response.data.data) {
  //         setIsConnected(true);
  //         setApiKey(response.data.data.api_key);
  //       }
  //     } catch (error) {
  //       console.error('Error checking TabiPayment status:', error);
  //     }
  //   };

  //   checkConnection();
  // }, []);

  return (
    <SectionContainer>
      <ModuleView>
        <Flex
          direction={{ base: 'column' }}
          align={{ base: 'flex-start' }}
          className="detail_container"
        >
          <Flex justify="center" align="center" gap="10px">
            <TabiPayment style={{ width: '20px', height: '20px' }} />
            <p className="SemiBold title">Tabi Payment</p>
          </Flex>
          <Flex direction={'column'} gap={'16px'} w={'100%'} pt={'16px'}>
            <Flex
              direction={'column'}
              align={'space-between'}
              justify={'space-between'}
              className="info"
            >
              <p>{formatMessage({ id: 'integrations.zohoCrm.description' })}</p>
              <br />
              <p>{formatMessage({ id: 'integrations.zohoCrm.benefits' })}</p>
              <Flex direction={'column'} gap={'0'}>
                <p style={{ marginBottom: '0' }}>
                  {formatMessage({ id: 'integrations.zohoCrm.benefit1.title' })}
                </p>
                <p>
                  {formatMessage({
                    id: 'integrations.zohoCrm.benefit1.description',
                  })}
                </p>
              </Flex>
              <Flex direction={'column'} gap={'0'} mt={'12px'}>
                <p style={{ marginBottom: '0' }}>
                  {formatMessage({ id: 'integrations.zohoCrm.benefit2.title' })}
                </p>
                <p>
                  {formatMessage({
                    id: 'integrations.zohoCrm.benefit2.description',
                  })}
                </p>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </ModuleView>
      <Button onClick={handleActivate}>
        {formatMessage({ id: 'activation' })}
      </Button>
      {showErrorModal && (
        <ErrorModal
          showErrorModal={showErrorModal}
          setShowErrorModal={setShowErrorModal}
          message={formatMessage({ id: 'integrations.zohoCrm.error' })}
        />
      )}
      {showBlockedModal && (
        <BlockedFeatureState
          title="استقبال المدفوعات غير متاح في باقتك الحالية"
          description="قم بالترقية للوصول إلى ميزة استقبال المدفوعات عبر Tabi Payment"
          onClose={() => setShowBlockedModal(false)}
        />
      )}
    </SectionContainer>
  );
}
